import React from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import DebitCreditAddForm from "../../components/DebitCredit/Add/DebitCreditAddForm";

class DebitCreditAddModal extends React.Component {
  render() {
    const { modalOpen, handleClose, user } = this.props;

    return (
      <div>
        <Dialog
          open={modalOpen}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">افزودن بدهی و طلب</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <DebitCreditAddForm
                isModal={true}
                handleClose={handleClose}
                user={user}
              />
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default DebitCreditAddModal;
